export const REQUIRED_APP_SCOPE_GROUPS = [
  {
    label: "APM (all reads)",
    scopes: [
      "apm_api_catalog_read",
      "apm_pipelines_read",
      "apm_read",
      "apm_remote_configuration_read",
      "apm_retention_filter_read",
      "apm_service_catalog_read",
      "apm_service_ingest_read",
      "continuous_profiler_pgo_read",
      "continuous_profiler_read",
      "debugger_read",
    ],
  },
  { label: "Dashboards", scopes: ["dashboards_read"] },
  {
    label: "Database Monitoring",
    scopes: ["dbm_parameterized_queries_read", "dbm_read"],
  },
  { label: "Error Tracking", scopes: ["error_tracking_read"] },
  { label: "Events", scopes: ["events_read"] },
  { label: "Incidents", scopes: ["incidents_read"] },
  {
    label: "Log Management (all reads)",
    scopes: [
      "logs_read_archives",
      "logs_read_config",
      "logs_read_data",
      "logs_read_index_data",
      "logs_read_workspaces",
    ],
  },
  { label: "Metrics", scopes: ["metrics_read", "timeseries_query"] },
  { label: "Monitors", scopes: ["monitors_read"] },
  { label: "Notebooks", scopes: ["notebooks_read"] },
  { label: "On-Call", scopes: ["on_call_read"] },
  { label: "Organization", scopes: ["org_management"] },
  { label: "Real User Monitoring", scopes: ["rum_apps_read"] },
  { label: "Service Level Objectives", scopes: ["slos_read"] },
  { label: "Software Delivery", scopes: ["cd_visibility_read", "ci_visibility_read"] },
  {
    label: "Synthetic Monitoring (all reads)",
    scopes: [
      "synthetics_default_settings_read",
      "synthetics_global_variable_read",
      "synthetics_private_location_read",
      "synthetics_read",
    ],
  },
  { label: "Teams", scopes: ["teams_read"] },
] as const;

export const REQUIRED_APP_SCOPES = REQUIRED_APP_SCOPE_GROUPS.flatMap((group) => group.scopes);
